
export const summaryCondition = (block) => {
    if (!block.content?.length) {
        return false
    }
    return !!block.content.find(t => {
        if (!t.indexOf) {
            return false
        }
        return t.indexOf("Summary:") !== -1 || t.indexOf("روژ وكات:") !== -1 || t.indexOf("مختصر الندوة:") !== -1
    })
}

const convertContent = (blocks): string[] => {
    if (!blocks) {
        return []
    }
    return blocks.map((data) => {
        if (typeof data === 'string') {
            return data
        } else {
            return blockContent(data).join(" ")
        }
    })
}

export const blockContent = (data): string[] => {
    if (data.type === 'span' &&
        data.content.length === 1 &&
        data.content[0].type === 'span') {
        const d = data.content[0]
        return convertContent(d.content)
    }

    return convertContent(data.content)
}


